module.exports = __webpack_public_path__ + "img/upload-id2.6ab6347f.png";